import { useAuth0 } from '@auth0/auth0-react';
import HomeRedirect from './home/home-redirect';
import PageLoadingComponent from '../components/PageLoading';

const AuthCallback = () => {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth0();

  if (isAuthLoading || !isAuthenticated) {
    return <PageLoadingComponent />;
  }

  return <HomeRedirect />;
};

export default AuthCallback;
